import { Directive, ElementRef, Input, Renderer2, OnDestroy } from '@angular/core';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';

@Directive({
    selector: '[keyboardNav]'
})
export class DropDownKeyboardNavDirective implements OnDestroy
{
    private _keyboardNav;
    constructor(private element: ElementRef, private renderer: Renderer2, private dropDownDirective: BsDropdownDirective) {
    }

    ngOnInit() {
        if (this._keyboardNav || typeof this._keyboardNav === "undefined") {
            this.renderer.listen(this.element.nativeElement, 'keyup', (event) => {
                this.onKeyUp(event);
            });
        }
    }

    ngOnDestroy() {
        this.dropDownDirective.isOpen = false;
    }

    onKeyUp(event: KeyboardEvent) {
        if (event.key == 'ArrowDown') {
            this.dropDownDirective.isOpen = true;
        }
    }

    @Input() set keyboardNav(condition: boolean)
    {
        this._keyboardNav = condition != false;
    }
}